import { render } from "./FullScreenZapisy.vue?vue&type=template&id=27c0052a&scoped=true"
import script from "./FullScreenZapisy.vue?vue&type=script&lang=js"
export * from "./FullScreenZapisy.vue?vue&type=script&lang=js"

import "./FullScreenZapisy.vue?vue&type=style&index=0&id=27c0052a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c0052a"]])

export default __exports__